module.exports = __webpack_public_path__ + "img/003-man-1.f4fb7d0d.svg";